import { render, staticRenderFns } from "./WineSupplierPriceModal.vue?vue&type=template&id=113d608d&scoped=true"
import script from "./WineSupplierPriceModal.vue?vue&type=script&lang=js"
export * from "./WineSupplierPriceModal.vue?vue&type=script&lang=js"
import style0 from "./WineSupplierPriceModal.vue?vue&type=style&index=0&id=113d608d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d608d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('113d608d')) {
      api.createRecord('113d608d', component.options)
    } else {
      api.reload('113d608d', component.options)
    }
    module.hot.accept("./WineSupplierPriceModal.vue?vue&type=template&id=113d608d&scoped=true", function () {
      api.rerender('113d608d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/WineSupplierPriceModal.vue"
export default component.exports